module.exports = __webpack_public_path__ + "b6f8b626865244aee0014858ca979794.jpg";